<p>You found an easter egg! Here is a cookie: 🍪</p>
<mat-dialog-actions>
  <button mat-flat-button color="accent" mat-dialog-close>Close</button>
</mat-dialog-actions>
